import { Avatar, Button, List, Modal, Tag, message } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { createAuthors, deleteAuthor, getAuthors } from "../../../api/postAPI";

interface AuthorModalProps {
  open: boolean;
  onClose: () => void;
  postId: number;
  onAuthors: any[];
  setOnAuthors: React.Dispatch<React.SetStateAction<any[]>>;
  authorList: any[];
  avatarUrls: Record<string, string>;
}

const AuthorModal = ({
  open,
  onClose,
  postId,
  onAuthors,
  setOnAuthors,
  authorList,
  avatarUrls,
}: AuthorModalProps) => {
  const isAdding = !(onAuthors?.length > 0);

  // 현재 포스트에 매핑된 authors에 존재하는지 검사
  const checkAuthor = (author: any) => {
    return !onAuthors.some((auth: any) => auth.name === author.name);
  };

  const handleAddAuthor = (author: any) => {
    setOnAuthors((prev: any) => [...prev, author]);
  };

  const handleDeleteAuthor = async (e: any, author: any) => {
    e.preventDefault();

    const deleteItem = onAuthors?.filter(
      (auth: any) => auth.name === author.name
    );
    if (!(deleteItem?.length > 0)) return;

    await deleteAuthor({
      postId,
      authorId: deleteItem[0].authorId,
    });

    setOnAuthors((prev: any) =>
      prev.filter((auth: any) => auth.name !== author.name)
    );
  };

  const onSave = async () => {
    try {
      const authors = onAuthors?.map((author: any) => author.userId);
      const data = await getAuthors({ postId });

      const newAuthors = authors.filter(
        (userId: string) => !data.some((e: any) => e.userId === userId)
      );

      await createAuthors({ postId, authors: newAuthors });
      message.success("Success to save authors.");
      onClose();
    } catch {
      message.error("Failed to save authors.");
    }
  };

  return (
    <Modal
      centered
      title={isAdding ? "Add author" : "Edit author"}
      open={open}
      footer={null}
      onCancel={onClose}
    >
      <List
        header={<h3>Authors List</h3>}
        dataSource={authorList ?? []}
        grid={{ column: 2, gutter: 8 }}
        renderItem={(item: any) => (
          <List.Item>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', border: '1px solid #f0f0f0', borderRadius: 8 }}>
              <List.Item.Meta
                avatar={<Avatar src={avatarUrls[item?.name]} />}
                title={<span>{item?.name}</span>}
              />
              {checkAuthor(item) && (
                <Button type="link" size="small" onClick={() => handleAddAuthor(item)}>
                  add
                </Button>
              )}
            </div>
          </List.Item>
        )}
      />
      <div>
        <h3>Selected Authors</h3>
        <ul style={{ paddingLeft: 0 }}>
          {onAuthors?.map((author: any, index: number) => (
            <Tag
              key={`${author.name}_${index}`}
              closeIcon={<CloseCircleOutlined />}
              onClose={(e) => handleDeleteAuthor(e, author)}
            >
              {author?.name}
            </Tag>
          ))}
        </ul>
      </div>
      <div style={{ textAlign: "end" }}>
        <Button type="primary" onClick={onSave}>
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default AuthorModal;
